(
    function (skyward, $, undefined)
    {
        skyward.massupdatecoursemaster = skyward.massupdatecoursemaster || {};

        "use strict";

        var meetDisplayPeriodCheckbox = "#SelectedField-MeetMeetDisplayPeriods";
        var meetDisplayPeriodDistinctMultiSelectEEL = "#Update-MeetMeetDisplayPeriods";
        var displayPeriodRotationCheckbox = "#SelectedField-MeetDisplayPeriodRotationID";
        var displayPeriodRotationSelectEEL = "#Update-MeetDisplayPeriodRotationID";

        var init = function (selector)
        {
            //Dependency logic does not trigger the checkbox change events automatically
            var massUpdateMeetDisplayPeriodDistinctMultiSelectEEL = $(selector).find(meetDisplayPeriodDistinctMultiSelectEEL);
            if (massUpdateMeetDisplayPeriodDistinctMultiSelectEEL)
            {
                massUpdateMeetDisplayPeriodDistinctMultiSelectEEL.on('change', skyward.massupdatecoursemaster.meetDisplayPeriodSelectEELCheckboxEventHandler);
            }

            var massUpdateMeetDisplayPeriodRotationSelectEEL = $(selector).find(displayPeriodRotationSelectEEL);
            if (massUpdateMeetDisplayPeriodRotationSelectEEL)
            {
                massUpdateMeetDisplayPeriodRotationSelectEEL.on('change', skyward.massupdatecoursemaster.displayPeriodRotationCheckboxEventHandler);
            }
        };

        skyward.massupdatecoursemaster.triggerChangeToUnrelatedButDependentCheckbox = function (currentCheckboxName, relatedCheckboxName)
        {
            var currentCheckbox = $(currentCheckboxName);
            var relatedCheckbox = $(relatedCheckboxName);

            if (currentCheckbox.prop('checked'))
            {
                if (currentCheckbox.hasClass('ui-disabled'))
                {
                    skyward.controls.enable(currentCheckbox);
                }
                skyward.controls.setValue(relatedCheckbox, "false");
                skyward.controls.disable(relatedCheckbox);
            }
            else
            {
                skyward.controls.enable(relatedCheckbox);
            }
        };

        skyward.massupdatecoursemaster.displayPeriodRotationCheckboxEventHandler = function ()
        {
            skyward.massupdatecoursemaster.triggerChangeToUnrelatedButDependentCheckbox(displayPeriodRotationCheckbox, meetDisplayPeriodCheckbox);
        };

        skyward.massupdatecoursemaster.meetDisplayPeriodSelectEELCheckboxEventHandler = function ()
        {
            skyward.massupdatecoursemaster.triggerChangeToUnrelatedButDependentCheckbox(meetDisplayPeriodCheckbox, displayPeriodRotationCheckbox);
        };

        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);